import React, { useState, useEffect, useRef } from "react";

import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useConfig } from "./ConfigContext";

export default function NutzergrafikAktuell({ users, estates, setSelectedUser, statConfig }) {
   const [graphData, setGraphData] = useState();
   const config = useConfig();

   useEffect(() => {
      let userdata = {};

      if (estates && users) {
         estates.forEach((item) => {
            let itemuser = item.elements.benutzer;
            if (!userdata[itemuser]) {
               userdata[itemuser] = Object.keys(statConfig.aktuell).reduce(
                  (oldObj, item) => ({ ...oldObj, [item]: [] }),
                  {},
               );
            }
            if (userdata[itemuser][item.elements.status2]) userdata[itemuser][item.elements.status2].push(item);
         });
         setGraphData(
            Object.keys(userdata).map((item) => {
               return {
                  ["name"]: users[item] ? users[item].Kuerzel : item,
                  ...Object.keys(statConfig.aktuell).reduce(
                     (oldObj, keyItem) => ({
                        ...oldObj,
                        [statConfig.aktuell[keyItem]]: userdata[item][keyItem] ? userdata[item][keyItem].length : 0,
                     }),
                     {},
                  ),
                  ["data"]: userdata[item],
                  ["userId"]: item,
               };
            }),
         );
      }
   }, [estates, users]);

   function renderCustomBarLabel({ payload, x, y, width, height, value, altLabel, isCurrency }) {
      return (
         <text x={x + width/2 } dx={20} y={y} fill="#eef" fontWeight={700}  fontSize={30} textAnchor="middle" dy={-7}>
            {isCurrency ? (
               <tspan textAnchor="middle">
                  {new Intl.NumberFormat("de-DE", {
                     style: "currency",
                     currency: "EUR",
                     maximumFractionDigits: 0,
                  }).format(value)}
               </tspan>
            ) : (
               <tspan textAnchor="middle">{value ? value : ""}</tspan>
            )}
            {altLabel && (
               // <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>
               <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>

                  {altLabel}
               </tspan>
            )}
         </text>
      );
   }

   function CustomTooltip({ active, payload, label }) {
      const isVisible = active && payload && payload.length;
      if (isVisible) {
      }

      return (
         <div
            style={{
               visibility: isVisible ? "visible" : "hidden",
               backgroundColor: "#fffe",
               borderRadius: "10px",
               color: "#000",
               padding: "10px",
               margin: "0 40px",
               boxShadow: "0 0 20px 2px #000",
            }}
         >
            {isVisible && (
               <>
                  <p className="label">
                     {users[payload[0].payload.userId]
                        ? users[payload[0].payload.userId].Name
                        : users[payload[0].payload.userId]
                          ? users[payload[0].payload.userId]
                          : payload[0].payload.userId}
                  </p>
                  <div>
                     <div style={{ display: "flex", flexDirection: "row" }}>
                        {Object.keys(payload[0].payload.data).map((item) => (
                           <div className="mx-1" key={"key_" + item}>
                              {statConfig.aktuell[item]}
                              <ul>
                                 {payload[0].payload.data[item].map((item2) => (
                                    <li>{item2.elements.objektnr_extern}</li>
                                 ))}
                              </ul>
                           </div>
                        ))}
                     </div>
                  </div>
               </>
            )}
         </div>
      );
   }

   return (
      <div className="projektstatus-l2 projektstatus-statistik" >
         <div
            style={{
               width: "100%",
               height: 350,
               position: "relative",
               overflow: "auto",
            }}
         >
            <div
               style={{
                  // position: "absolute",

                  width: "100%",
                  zIndex: 100,
               }}
            >
               <h2 style={{top: 0,zIndex: 101, backgroundColor: "#0004", margin: 0, paddingTop: "8px", position: "sticky", width: "100%", textAlign: "center" }}>
                  Aktuelle Objekte pro Betreuer und Status
               </h2>
               {graphData && (
                  <div >
                     <ResponsiveContainer
                        style={{ background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                        width={"100%"}
                        height={350}
                     >
                        <BarChart
                           data={graphData}
                           margin={{
                              top: 30,
                              right: 0,
                              left: 0,
                              bottom: 5,
                           }}
                           onClick={(e) => {
                              setSelectedUser(e.activePayload[0].payload.userId);
                              console.log(e.activePayload[0].payload.userId);
                           }}
                        >
                           <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "normal" }} />
                           <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} />
                           <Tooltip
                              cursor={false}
                              isAnimationActive={false}
                              // position={{ y: 0, dx: 50 }}
                              content={CustomTooltip}
                           />
                           <Legend /* content={(e)=>renderCustomLabel({...e})} */ />
                           {Object.keys(statConfig.aktuell).map((item) => (
                              <Bar
                                 key={"key_" + item}
                                 dataKey={
                                    config.verkaufsStatusFarben[item] ? config.verkaufsStatusFarben[item].name : ""
                                 }
                                 fill={
                                    config.verkaufsStatusFarben[item] ? config.verkaufsStatusFarben[item].color : "#40f"
                                 }
                                 label={renderCustomBarLabel}
                                 onClick={(e) => {
                                    const { payload } = e;
                                    console.log(payload);
                                 }}
                              />
                           ))}
                        </BarChart>
                     </ResponsiveContainer>
                  </div>
               )}
            </div>
         </div>
         </div>
   );
}
